/**
 * Seller configuration shared between backend and frontend.
 * Keep this file in sync with backend/config/sellers.js
 */
const SELLERS = [
  { email: 'cristian@kummayorista.com', id: '236', name: 'Cristian' },
  { email: 'lucas@kummayorista.com',    id: '187', name: 'Lucas' },
  { email: 'raul@kummayorista.com',     id: '325', name: 'Raul' },
  { email: 'ruben@kummayorista.com',    id: '326', name: 'Ruben' },
  { email: 'info@kummayorista.com',     id: '777', name: 'Eliezer' },
  { email: 'gabriel.perez@kummayorista.com', id: '774', name: 'Gabriel Pérez' },
  { email: 'gcarlesso976@gmail.com',    id: '738', name: 'Gabriel Carlesso' },
];

export const isSellerEmail = (email = '') =>
  SELLERS.some((seller) => seller.email === email);

export default SELLERS;
